import type { PromptFormData, UploadedDocument } from './types';

/** DOCX/PDF worksheets go through file_extraction + prompt_question_gen. */
export function isWorksheetSourceFile(name: string): boolean {
    return /\.(docx|pdf)$/i.test(name);
}

/**
 * Split uploaded docs into a worksheet File (extract pipeline) vs reference URLs.
 */
export function buildDocumentSubmitFields(
    documents: UploadedDocument[],
): Pick<PromptFormData, 'metadata' | 'sourceDocument'> {
    const worksheetDoc = documents.find((doc) => doc.sourceFile != null);
    const referenceDocs = documents.filter((doc) => !doc.sourceFile && doc.url);

    const result: Pick<PromptFormData, 'metadata' | 'sourceDocument'> = {};
    if (worksheetDoc?.sourceFile) {
        result.sourceDocument = worksheetDoc.sourceFile;
    }
    if (referenceDocs.length > 0) {
        result.metadata = {
            document_urls: referenceDocs.map((doc) => doc.url),
            document_names: referenceDocs.map((doc) => doc.name),
        };
    }
    return result;
}
